import { useEffect, useState } from 'react';
import { useJoveBreakpoint } from '../useBreakpoint';
/** Motion switch for portal pages: disables framer-motion animations on mobile or when reduced motion is preferred */

export var usePortalMotion = function usePortalMotion() {
  var _useJoveBreakpoint = useJoveBreakpoint(),
      isMobileLayout = _useJoveBreakpoint.isMobileLayout;

  var _useState = useState(false),
      reduceMotion = _useState[0],
      setReduceMotion = _useState[1];
  /**
   * effects
   */


  useEffect(function () {
    if (false || !window.matchMedia) return;
    var query = window.matchMedia('(prefers-reduced-motion: reduce)');
    setReduceMotion(query.matches);

    var changeCallback = function changeCallback(event) {
      return setReduceMotion(event.matches);
    };

    query.addEventListener('change', changeCallback);
    return function () {
      return query.removeEventListener('change', changeCallback);
    };
  }, []);
  return {
    motionEnabled: !isMobileLayout && !reduceMotion,
    isMobileLayout: isMobileLayout
  };
};